import axios from "axios";
import { baseURL } from "../config";

export const fetchEvents = async (page, params) => {
  const response = await axios.get(`${baseURL}/event?page=${page}`, {
    params,
  });
  return response.data;
};

export const fetchEventDetails = async (id) => {
  const response = await axios.get(`${baseURL}/event/${id}`);
  return response.data;
};
